import React from "react";
import Header from "../Header";
import Footer from "../Footer";

import { Link } from "react-router-dom";
import AudioPlayer from "../Audio/AudioPlayer";

const BlogDetails9 = (props) => {
  const img1 = "/assets/wp-content/uploads/2018/12/ramdev-gallery11.jpg";
  return (
    <>
     <meta name="keywords" content="બાબા રામદેવ , રામદેવજી,  રામદેવ પીર, રામશા પીર, Baba Ramdev, Ramdevji, Ramdev Pir, Ramshapir" />
      
      {/* <div className="body_wrap">
        <div className="page_wrap"> */}


      <Header />
      <div
        data-elementor-type="cpt_layouts"
        data-elementor-id="46"
        className="elementor elementor-46"
      >
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-52ebb12  elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="52ebb12"
          data-element_type="section"
          data-settings='{"background_background":"classic"}'
          style={{ height: "30rem", marginBottom: "5rem" }}
        >
          <div className="elementor-background-overlay"></div>
          <div className="elementor-container elementor-column-gap-extended">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-ae9d67e sc_inner_width_none sc_layouts_column_icons_position_left"
              data-id="ae9d67e"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <section
                  className="elementor-section elementor-inner-section elementor-element elementor-element-fcf91b3 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="fcf91b3"
                  data-element_type="section"
                >
                  <div className="elementor-container elementor-column-gap-extended">
                    <div
                      className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-93dfaf4 sc_inner_width_none sc_layouts_column_icons_position_left"
                      data-id="93dfaf4"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="sc_layouts_item elementor-element elementor-element-847c2c5 sc_fly_static elementor-widget elementor-widget-spacer"
                          data-id="847c2c5"
                          data-element_type="widget"
                          data-widget_type="spacer.default"
                          style={{ height: "8rem" }}
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-spacer">
                              <div className="elementor-spacer-inner"></div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="sc_layouts_item elementor-element elementor-element-8fe49e3 sc_fly_static elementor-widget elementor-widget-trx_sc_layouts_title"
                          data-id="8fe49e3"
                          data-element_type="widget"
                          data-widget_type="trx_sc_layouts_title.default"
                        >
                          <div className="elementor-widget-container">
                            <div
                              id="trx_sc_layouts_title_515615674"
                              className="sc_layouts_title sc_align_center with_content without_image without_tint"
                            >
                              <div className="sc_layouts_title_content">
                                <div className="sc_layouts_title_title">
                                  {" "}
                                 
                                </div>
                                <div className="sc_layouts_title_breadcrumbs">
                                  <div className="breadcrumbs">
                                   
                                    
                                  </div>
                                </div>
                              </div>
                            </div>{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* <div className="menu_mobile_overlay"></div>
      <div className="menu_mobile menu_mobile_fullscreen scheme_inherit">
        <div className="menu_mobile_inner">
          <a className="menu_mobile_close icon-cancel"></a>
          <Link to={'/'} className="sc_layouts_logo">

            <img
              src={logoimg}
              alt="Vihara"
              width="134"
              height="78"
            />{" "}
          </Link>
          <nav
            className="menu_mobile_nav_area"
            itemScope
            itemType="//schema.org/SiteNavigationElement"
          >
            <ul id="menu_mobile_1510458944">
              <li
                id="menu_mobile-item-203"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-203"
              >
                <a href="/">
                  <span>Home</span>
                </a>

              </li>
              <li
                id="menu_mobile-item-204"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-204"
              >
                <a href="#">
                  <span>Gallery</span>
                </a>
                <ul className="sub-menu">
                  <li
                    id="menu_mobile-item-209"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-209"
                  >
                    <a href="/Audio">
                      <span>Audio</span>
                    </a>
                  </li>
                  <li
                    id="menu_mobile-item-208"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-208"
                  >
                    <a href="/Video">
                      <span>Video</span>
                    </a>
                  </li>
                  <li
                    id="menu_mobile-item-206"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-206"
                  >
                    <a href="/Gallery2">
                      <span>Images</span>
                    </a>
                  </li>

                </ul>
              </li>
              <li
                id="menu_mobile-item-224"
                className="menu-item menu-item-type-custom menu-item-object-custom current-menu-ancestor current-menu-parent menu-item-has-children menu-item-224"
              >
                <a href="#">
                  <span>About</span>
                </a>
                <ul className="sub-menu">
                  <li
                    id="menu_mobile-item-447"
                    className="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-407 current_page_item menu-item-447"
                  >
                    <a
                      href="/About"
                      aria-current="page"
                    >
                      <span>Ashram</span>
                    </a>
                  </li>

                  <li
                    id="menu_mobile-item-449"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-449"
                  >
                    <a href="/plan-visit">
                      <span>Plan a Visit</span>
                    </a>
                  </li>
                </ul>
              </li>

              <li
                id="menu_mobile-item-316"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-316"
              >
                <a href="/BlogMain">
                  <span>Stories</span>
                </a>
              </li>
              <li
                id="menu_mobile-item-312"
                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-312"
              >
                <a href="/Books">
                  <span>Books</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
 */}



      <div className="page_content_wrap blog-details">
        <div className="content_wrap" >
          <div className="content">
            <div id="container" className="give-wrap container">
              <div id="content" role="main">
                <div
                  id="give-form-288-content"
                  className="post-288 give_forms type-give_forms status-publish has-post-thumbnail"
                >
                  <div
                    id="give-sidebar-left"
                    className="give-sidebar give-single-form-sidebar-left"
                  >
                    <div className="images">
                      <img
                        width="1024"
                        height="576"
                        src={img1}
                        className="attachment-large size-large wp-post-image blog-img"
                        alt=""
                        decoding="async"
                        sizes="(max-width: 1024px) 100vw, 1024px"
                      />
                    </div>
                  </div>
                  <div className="summary entry-summary">
                    <h2 itemProp="name" className="give-form-title entry-title">
                      સતી ડારલદે’ની સમાધિ

                    </h2>{" "}
                    <div
                      id="give-form-288-wrap"
                      className="give-form-wrap give-display-onpage"
                    >
                      <div className="give-goal-progress">
                        <div
                          className="raised blog-title"
                          
                        >
                          <span className="income">સતી ડારલદે’ની સમાધિ</span>
                        </div>
                      </div>

                      <div
                        id="give-form-content-288"
                        className="give-form-content-wrap give_pre_form-content"
                      >
                        <p className="paragraph-content">       
                        કણ્વ અંગિરા બૃહસ્પતિ, આતિથ્ય ગાલવધામ,
                          પાંચ ઋષિના આશ્રમો, પાંચાલયનું નામ.
                          પૂર્વે ઉત્તર દિશાથી પશ્ચિમ દિશા સુધી અયોધ્યાના રાજા માંધાતાની રાજ હકુમત હતી. પાંચાળ ભૂમિના છ ોજનના વિસ્તારમાં માંડવગઢ નામની નગરી હતી. દ્વાપરમાં એ ભૂમિ પર દ્રુપદ રાજાએ દ્રુપદનગરી વસાવી હતી. દ્રુપદે પોતાની પુત્રીનો સ્વયંવર રચ્યો, અને જે મચ્છવેધ કરે એ પોતાની પુત્રીને વરે એવો નિર્ધાર કર્યો હતો; તેથી પાંડુપુત્ર અર્જુને મચ્છવેધ કરી વિજય મેળવ્યો અને દ્રૌપદીને વર્યા હતા.
                          એ ભૂમિ શૌર્યવટ-સોરઠ નામથી પ્રસિદ્ધ થઈ અને સોરઠનો વિસ્તાર થતાં સૌરાષ્ટ્ર નામે પ્રસિદ્ધ થઈ. એ ભૂમિમાં મચ્છુ નદીના કાંઠે મોરલો તથા મોરલી નામનાં બે નાના મોટાં ગામડાં હતાં, એ કચ્છના રાજાએ પોતાના અશ્વપાલ રાવત રણસિંહને બક્ષીસ આપ્યાં હતાં. રણસિંહે ગામનું નામ મોરલી ફેરવીને ‘ઢેલડી’ રાખ્યું હતું.સોરઠ ભોમનાં ઢેલડી ગામે, રાજા રાવત રણસિંહ નામે,
                          ઠામ ઠામ ઠીમત ઠકુરાઈ, ધર્મ પંથે સમજે નહીં કાંઈ. રણસિંહ ધર્મપંથ, પુણ્ય, દાન-દર્શન, કથાકીર્તન, કે ભજન ભાવ વિહોણો હતો. એને રાજ મળતા બ્લેકી ગયો હતો અને ભોગવિલાસના વિકારમાં ઘેરાયેલો હતો. પ્રજા એને દારૂડિયો કહીને સંબોધતી.
                          રાવતનો રાજા થતાં, થયો વિકાર ઘમંડ,
                          વિલાસ વૈભવ ભોગથી, પામર બન્યો પ્રચંડ.
                          રાવતને રાજ્ય મળવાથી એનો ઘમંડ વધતો ગયો. તે રાતદિ ભોગવિલાસમાં ગળાબૂડ રહેતો. રણસિંહ સામાન્ય રાવત હતો, પરંતુ રાજા થતાં તો પ્રચંડ બની


                        </p>
                        <p className="paragraph-content" >
                          ગયો હતો. પ્રજા પ્રત્યે એ દુર્લક્ષ રાખવા લાગ્યો.
                          નામનો
                          ઢેલડી ગામના પાદરમાં ચમાર જાતિનાં ખોરડાં હતાં. તેમાં ‘ખીમડા’ ભક્ત રહેતો. તે જાતનો ચમાર હોવાથી તેણે ફળિયામાં કુંડ કર્યો હતો; કુંડમાં આવળની તાજી ડાળિયો અને ફૂલ લાવી પાણીમાં પલાળતો અને એમાં ચામડાને કુાં કરીને રંગતો અને પ્રભુનું ભજન-કીર્તન કરી ભક્તિભાવથી જીવન ગુજારતો હતો. ખીમડો રામદેવપીરનો ભક્ત હતો. નેક, ટેક અને વિવેકમાં એ નિ હોવાથી, જ્યાં જ્યાં પાટનો ઓચ્છવ થતો હોય ત્યાં એ જઈ પહોંચતો અને બનતી સેવા કરતો. એના સેવાભાવથી સહુ સાધુ, સંતો અને ભક્તો એને કોટવાળ કહેતા એની સ્ત્રીનું નામ ડા૨લદે' હતું.
                          ડારલદે’૫૨મપવિત્ર આચરણવાળી હોવાથી એને સૌ સતી તરીકે ગણતાં હતાં. બેસતાં-ઊઠતાં, હાલતાં-ચાલતાં, એ રામદેવજીનું સ્મરણ કરતી અને ભજન ભાવમાં તલ્લીન રહેતી.
                          શિવ-પાર્વતીએ આદિપંથને નિજીયાધર્મનું નામ આપીને ગુરુ દત્તાત્રેય, મક્કેન્દ્રનાથ, ગોરખનાથ વગેરેને આદિ ધર્મની દિક્ષા આપી હતી. એ આદેશનો પ્રચાર કરવા ધર્મધૂરંધરોએ પ્રત્યેક માસની સુદી બીજ, ત્રીજ, પાંચમ, અગિયારસ, તેરસ અને પૂનમને દિવસે પાટમંડપનો ઉત્સવ કરવાનો નિયમ કર્યો હતો.
                          સત્યુગથી આ પ્રથાની પરંપરા પ્રચારમાં છે. સાધુ-સંતો, ભક્તો, જતિ-સતી, સિદ્ધ- યોગી, સેવકો, પાટપૂજા મંડપને પવિત્ર ગણે છે. આ પાટોત્સવના મંડપમાં જતિ- સતીના ભાવવાળાં નરનારીઓ એકઠાં થઈ પૂજા-ધૂપ, દીપ કરી ભગવાન શ્રી રામદેવજીને આરાધી ભજનો, સ્તુતિ, કીર્તન ગાઈ જમૈયા અને સત્સંગ કરી જમા જાગરણ કરે છે. જમા-જમૈયો, જુમલો, જમેલો, મેળો, મંડપમેળો એવાં અનેક નામે આ પાટોત્સવ ઓળખાય છે. આખી રાત અખંડ ભજનાનંદી બની જાગરણ કરે છે. એનું નામ જમા જાગરણ કહેવાય છે.
                          આ જમા જાગરણમાં એકત્ર થયેલાં નરનારીઓના સમૂહને ગતગંગા – ગતનાં ગોઠી અને ગતમાર્ગી પણ કહેવામાં આવે છે.
                          ચોપાઈ
                          બીજ અષાઢી થાવર વારે, પાટોત્સવ ખીમડાને દ્વારે,
                          જમા જાગરણ ને સતસંગા, મળ્યાં જતિ સતી ગતગંગા.
                          અષાઢી બીજને થાવરવાર-શનિવારના પરમ પવિત્ર દિવસે ખીમડાને ઘેર
                          પોત્સવ
                          સતી રા'ની સાધિ
                          હોવાથી તેમાં સાધુ સંતો, ઇતિ સતી આવ્યાં હતાં. આખી રાત સજય અખંડ જાગરણ કરી ભજનો ગાતાં હતાં. રાત વીતી અને પરોઢ થવા બાવ્યું. ત્યાં ડારેલ 'એ ખીમાને કહ્યું કે, પાણીની તાલ પ
                          સુધી પહોંચી
                        </p>
                        <p className="paragraph-content" >
                          બીજ અષાઢી થાવર વારે, પાટોત્સવ ખીમડાને દ્વારે,
                          જમા જાગરણ ને સતસંગા, મળ્યાં જતિ સતી ગતગંગા.
                          અષાઢી બીજને થાવરવાર-શનિવારના પરમ પવિત્ર દિવસે ખીમડાને ઘેર
                          સતી પ્રાગ બડે”નો અબાધિ
                          ''
                          પાટોત્સવ હોવાથી તેમાં સાધુ સંતો, જતિ-સતી આવ્યાં હતાં. આખી રાત સજા અખંડ જાગરણ કરી ભજનો ગાતાં હતાં. ગત વીતી અને પરોઢ થવા આવ્યું. ત્યાં ડાયલદે ’ને ખીમડાને કહ્યું કે, પાણીની તાલ પડે એમ લાગે છે. ગોળાનું પાકી બપોર સુધી પહોંચી શકે તેમ નથી. પડોશણનો સાથ છે. તો કૂવેથી એક બેડું
                          ભરી આવું ?
                          ‘સતી ! પ્રભાત થઇ ગયું છે. હવે પાણી ભરવા જવાનો મત કરશો નહીં. રાવત રણસિંહ સવારથી જ રખડવા નીકળી પડે છે. તેની દ્રષ્ટિએ પડવું એ સારું નથી. સતી, સેવકો ઘણાં છે. આથી પાણીની તાણ પાડવા નહીં દે.”
                          'નાથ ! સેવામાં ભાગીદારી શું કામ રાખવી ?' 'તો...એક બેડું ભરી આવો, પાર્ટમંડપ વધાવાને તો હજી વાર છે.’ ખીમડાના કહેવાથી ડાલદે' પડોશણો સાથે પાણી ભરવા નીકળ્યાં. રાજાની કામુકતાના કારણે ગામની સ્ત્રીઓ દિવસે પાણી ભરવા ભાગ્યે જ નીકળતી.
                          રાજમહેલની અટારીમાં રણસિંહ દાતણ કરતો બેઠો હતો. એણે દૂરથી પનિહારીઓ પર નજર કરતાં ડારલદે'ને જોઈને તેના રૂપતેજથી મોહમુગ્ધ થઈ ગયો. તે આશ્ચર્યચકિત થઈ તત્કાલ પોતાનો અથ લઈ બજારમાં ચારમાર્ગી ચોક જે માણેકચોક નામથી ઓળખાતો તે માણેકચોકમાં આવી અશ્વ પરથી નીચે ઊતરીને
                          ઊભો રહ્યો .
                          ચોપાઈ
                          ગૌરાંગી શીશી વદના નમણી, નિરખી રણસિંહે રૂપરમણી,
                          કરીને આવ્યો અશ્વ સવારી, દેખી ભયભીત થઈ પનિહારી.
                          એક જ ટર્સ મીટ માંડીને ઊભેલા રાજાએ પનિહારી વૃંદને આવતું દીઠું. રાજાની નજર ડારલદે' પર પડી અને સ્થિર થઈ ગઈ.
                          ચોપાઈ
                          ગજગામીની સમ ચાલે હલકે, બ્રહ્મતેજ નયનોમાં ઝળકે,
                          આંતરી ઊભો વેણ ઉચ્ચારી, રૂપ પદ્મણી કોની નારી ? પનિહારીઓ સામે જઈ રાજા ડારલદે'ને આંતરી ઊભો રહ્યો અને બોલ્યો : ‘રૂપપદ્મણી ! તું કોની સ્ત્રી છે ! તારે પાણીનાં બેડાં ઊંચકવાનાં હોય ? ગામમાં ક્યાં રહે છે ? તરાં પતિનું નામ શું ? શું ધંધો કરે છે ?' રાજાએ પૂછ્યું.
                          ‘અન્નદાતા ! પ્રજાપાલક પિતા ! મારા પતિનું નામ ખીમડો. અમે ગામની બહાર
                        </p>
                        <p className="paragraph-content" >
                          રહીએ છીએ . જાતના ચમાર છીએ. આવળ લાવી પાણીના કુંડમાં પલાળીને રંગવાનો અમારો ધંધો છે, મને રોકો નહીં. મારે ઘેર પાટોત્સવ છે. વધાવવાનો છે ! જવા દો બાપુ !' ડારલદે’એ નીચી નજરે કહ્યું. ‘ઘેલી ! આજથી તારું ભાગ્ય ઊઘડ્યું છે ! તારા સામે ઢેલડી નગરનો ૨ તેડવા આવ્યો છે. એ તને આવા પાણી સારવા કેમ દે ? ચાલ મારી સાથે '' : આવીને ઊભો છે. તને રાજમહેલનાં સુખ સાહેબી આપવા, રાજરાણી બનાવવ
                          પ્રમાણે રાજા બોલ્યો.
                          ‘બાપુ ! હું તો તમારી દીકરી છું. કૂડી નજર, કૂંડા વિચાર, ફૂડાં વેણ કાઢવા જીભના લવે લવે ઘોર પાપ ગણાય છે.’ ડારલદે’એ વિનયપૂર્વક કહ્યું.
                          ‘ડારલદે’ ! તું જ્ઞાની છે ! તારા આવા જ્ઞાનને સાંભળવા માટે તો તને તેડીજ જવી પડશે. ચાલ !' એમ કહી રણસિંહે ડારલદે’ના ઓઢણાનો છેડો પકડ્યો. દૂ
                          ઊભેલી સાથીદાર પડોશણો થરથર ધ્રૂજવા લાગી.
                          ‘બાપુ ! બાપુ ! છેડો મૂકો ! ડાલરદે'ને દીકરી જાણી દયા કરો. મને અડશો નહીં. હું ચમાર છું.’
                          ‘અરે, ગાંડી ! હાથમાં આવેલું રતન ગુમાવે એવો રણસિંહ મૂરખ નથી.’
                          સોરઠો
                          વંઠે રાજા ભોમનો, વર્ષે કુટુંબે ડખા,
                          તે દિ’ ધન, ધરતી ને પખા, ત્રણેય મંડે હાલવા.
                          રાજા સમજ્યો નહીં. એ વખતે ડારલદે’એ જીવતાં સમાધિ લેવાનો દ્દઢ નિર્ણય કરી લીધો. નીચે માથું નમાવી ધરતીને પગે લાગી. બેડામાંથી પાણી છંટકાવ કર્યો અને મેઘગંભીર વાણીથી બોલ્યાં :
                          ચોપાઈ
                          સુણો સહુ પાડોશણબાઈ, લઉં સમાધિ આ સ્થળ માંહી,
                          સમાચાર ખીમડાને દેજો, કોશ કોદાળી લાવે કેજો.
                          ‘હે સહિયરો ! તમે મારા નાથ ખીમડાને સમાચાર આપો અને કહો કે કોશ- કોદાળી લઈને જલદી આવે. હું આ ઠેકાણે જીવતાં સમાધિ લેવાની છું. પાટમંડપમાં બિરાજેલા જતિ-સતી ગતગંગાને મારા છેલ્લા રામ રામ ! જય રામાપીર કહેજો.' આમ કહી ડારલદેએ ઘુંઘટ હટાવી દીધો અને લાલ આંખો કરી બોલી :
                          સતી કારલદે'ની સમાધિ
                          `ઝારા રાજા ! બાપ થઈને
                        </p>
                        <p className="paragraph-content" >
                          નાના કા, કાશ કાંદાળી લાવે કેજો.
                          ‘હે સહિયરો ! તમે મારા નાથ ખીમડાને સમાચાર આપો અને કહો કે કોશ- કોદાળી લઈને જલદી આવે. હું આ ઠેકાણે જીવતાં સમાધિ લેવાની છું. પાટમંડપમાં બિરાજેલા જતિ-સતી ગતગંગાને મારા છેલ્લા રામ રામ ! જય રામાપીર કહેજો.' આમ કહી ડારલદેએ ઘુંઘટ હટાવી દીધો અને લાલ આંખો કરી બોલી :
                          તાર
                          જેવા
                          સી કારલદે'ની સમાધિ
                          હે ગોઝારા રાજા ! બાપ થઈને દીકરીની છેડતી કરી કે નુગરા !' સતીના તીખા ! આટલા શબ્દો સાંભળતાં રાજાના અંગમાં વીજળી જેમ આંચકો લાગ્યો. ! તે ઘોડેસ્વાર થઈ મહેલમાં આવ્યો. પણ જે હાથે તેણે ડાલદે’નો પાલવ
                          અને તરત
                          શો હતો તે હાથ જૂઠો થઈ ગયો !
                          દોહા
                          કરી સતીની છેડતી, સ્વધર્મ ભૂલ્યો રાય,
                          અર્ધાંગે અપંગ બન્યો, દાહ દેહની માંથ.
                          રણસિહનું હૃદય કંપી ઊઠયું ! તે પશ્ચાત્તાપ કરતો મહેલમાં આવ્યો, પરંતુ એનો ! ખોટો પડી ગયો. કંપતા શરીરનો અર્ધ્યભાગ નિર્જીવ બની ગયો. રાણીની ઠાસીઓ પાણી ભરીને આવી અને ડારલદે'ની છેડતીની વાત રાણીને કરી. વાત સાંભળી રાણી પ્રભાવતીનું મોં પડી ગયું. તેણે રાજા પાસે જઈને કહ્યું : ‘મહારાજ ! આ તમને શું સૂઝ્યું ?' ‘પ્રભા ! રણસિંહને ભાવીએ ભુલાવ્યો. પ્રભા ! હું મહાપાતકી બન્યો . રૂપના અંબારથી અંજાઈ ગયો. મતંગ જેવું મન પતંગ બન્યું. દીપકની ઝાળમાં ઝંપલાવવાનું માઠું પરિણામ આવ્યું. મને ખીમડા પાસે લઈ જાવ. પીડા સહન કરી શકતો નથી. મને ડાલરદે’નાં દર્શન કરાવો ! એ સમાધિ લેવાનાં રાજા પશ્ચાત્તાપ કરીને રોવા લાગ્યો. પ્રભાવતીનો આત્મા કકળી ઊઠ્યો.
                          પનિહારીઓએ ખીમડાને ઘેર આવી વિસ્તારપૂર્વક વાત કરી : ‘સતી ડારલદે’ માણેકચોકમાં બેઠાં છે. રાજાએ તેમના પાલવના છેડાને સ્પર્શ કરવાથી એ શીલવંત સતીએ ત્યાં જ જીવતાં સમાધિ લેવાનો નિર્ણય કર્યો છે. કોશ-કોદાળી લઈ તમને ત્યાં જવાનું કહેણ મોકલ્યું છે. પાટમંડપમાં ગતગંગાએ આ વાત સાંભળીને સૌ આમાં બની ગયાં ! ‘રાજાએ ભારે ભૂંડાં કામ કર્યાં. આગમાં હાથ નાખ્યો ?' ઉગમશી બાવાએ નિશ્વાસ નાંખીને કહ્યું.
                          પાટ વધાવી, પ્રસાદ વહેંચી, પૂર્ણાહુતી કરી, સર્વે માણેકચોકમાં આવ્યાં. કોશ-કોદાળી લઈને ખીમડો આવ્યો અને સતી સામે ઊભો રહ્યો. ડા૨લદે' ખીમડાને બેસવાનો સંકેત કરી મૌન રહી. જતિ, સતી અને પ્રજાજનોમાં કેર વર્તાઈ ગયો. રાજાના દુષ્કૃત્ય પ્રત્યે ધિક્કાર ફીટકાર વરસાવતી સ્ત્રીઓ ડારલદે' સામે જોઈ, એની દયનીય દશા નિહાળી આંસુ સારતી હતી.
                          રાજા પ્રભાવતી પોતાનાં દાસ, દાસીઓ અને અપંગ બનેલા રાજાને લઈ માણેકચોકમાં આવ્યાં. માનવ મેદનીથી વિશાળચોક ઊભરાઈ ગયો હતો.
                        </p>
                        <p className="paragraph-content" >
                          કોશ-કોદાળી લઈને ખીમડો આવ્યો અને સતી સામે ઊભો રહ્યો. ડારલદ’ ખામડાન બેસવાનો સંકેત કરી મૌન રહી. જતિ, સતી અને પ્રજાજનોમાં કેર વર્તાઈ ગયો. રાજાના દુષ્કૃત્ય પ્રત્યે ધિક્કાર ફીટકાર વરસાવતી સ્ત્રીઓ ડારલદે' સામે જોઈ, એની દયનીય દશા નિહાળી આંસુ સારતી હતી.
                          રાજા પ્રભાવતી પોતાનાં દાસ, દાસીઓ અને અપંગ બનેલા રાજાને લઈ માણેકચોકમાં આવ્યાં. માનવ મેદનીથી વિશાળચોક ઊભરાઈ ગયો હતો.
                          ૯૪
                          રાણી પ્રભાવતી રાજાને ડારલદે' પાસે ગઈ ગયાં અને ખિન્ન હૃદયે આસું સા કહ્યું : 'મા ! જુગજોગણ ! હું કયા શબ્દોમાં તમારી પ્રાર્થના કરું ? કઈ રીતે સુ રીઝાવું ? કઈ પ્રાર્થનાથી તમારી પ્રસન્નતા મેળવું ? હું તમારી દીકરી છું, મા
                          મારા સામે નજર કરી મારા પતિનો અપરાધ ક્ષમા કરો !!
                          પતિતપાવન
                          ‘સતી ! હું ઘોર પાપ કરી બેઠો ! પાવકજ્વાળાને પકડવાનું વિચાર્યું અને ચકડોય ચડેલા ચિત્તનાં ચાળે ચડી ગયો, મા ! મા મને ક્ષમા કરો, ડારલદે' ! મને પુત્ર ગણી અપરાધની માફી આપો.'
                          સૂત્ર
                          ગતગંગાનાં બિરાજેલા સમર્થ સંતો, સાધુઓ, ભક્તો અને ખીમડાને રાજા અને
                          રાણી ગદ્ગદકંઠે પ્રાર્થના કરવા લાગ્યાં.
                          ‘રાણી ! હવે કલ્પાંત, વિલાપ ! કરવાથી ડા૨લદે'નો નિર્વાણ-નિશ્ચય કો ફેરવી શકે તેમ નથી. હવે તો આ સ્થળ જ સવરામંડપ બની ગયું છે. દૂરદૂરથી સિદ્ધ સંતો આવશે. અમારા આરાધ્ય દેવ રામદેવજી પધારશે અને સતીની સમાધિની પૂર્ણાહુતી થશે. ત્યાં સુધીનો જમૈયો અહીં જ નિર્ધાર્યો છે.’
                          ‘ખીમડા બાપુ ! મારા પાપને હવે માફ કરો. હવે હું તમારા સહુને શરણે છું. નુગરાને સુગરો બનાવો, મને પ્રમોદીને સેવાકાર્ય સોંપો . હું વૈભવ વિલાસનો ત્યાગ કરીને અહીં આવ્યો છું. કાં તો પ્રમોદો ! નહીંતર મેં નિશ્ચય કર્યો છે કે, સતી ડારલદે’ની સમાધિ ટાણે ખીમડાને દ્વારે મારે દેહ છોડવો ! હું અન્નજળનો ત્યાગ કરી પૂરા નિર્ધારથી અહીં સંતોના શરણે અને સતી ડારલદે'ને માતા ગણી એને ખોળે મારું માથું ધરવા આવ્યો છું.' રણસિંહે આ પ્રમાણે રડતાં રડતાં કહ્યું
                          સંતમંડપે કાશીથી કોટવાળ ભૈરવનાથને બોલાવ્યા અને સંતમેળામાં પધારવા ધર્મધુરંધરોને, નેજાધારીઓને વાયકબીડાં મોકલ્યાં. રાજારાણીએ અન્નભંડાર, ધનભંડાર ખુલ્લા મૂક્યા. વિશાળ ચોકમાં મંડપારોપણ થયું. રાત- દિવસ અખંડ ધૂન થવા લાગી.
                          દોહા
                          જતિ સતી સંતો સુધીર, પળપળ સમરે રામાપીર, નવનાથ ને બાવનવીર, પળપળ સમરે રામાપીર.
                          ગામનાં નરનારીઓ અખંડધૂનની ઘોષણા ગજાવવા લાગ્યાં. પરમપીર રામદેવની જય ! ધરમવીર રામદેવની જય !'
                        </p>
                        <p className="paragraph-content" >
                          લખમો જેસંગ ભારિયો, હાલો હલો ધીર.
                          દેવતણખી લીલમબાઈ, ઢાંગો ને વનવીર,
                          ભૈરવનાથે કોટવાળે વાયક બીડલાં સ્થળે સ્થળે પહોંચાડવાથી બીડાં વધાવીને નામાંકિત નેજાધારીઓ ઢેલડી ગામે આવી પહોંચ્યા !
                          રશુંથી લખમોમાળી, વીણનગરથી રૂપાંદેનો પતિ જેસંગ ભારિયો દેવાયતપંડિતના ચેલા, કોળાંભા ઊંડ પ્રદેશના હાલો અને હુલો, સખપરના કુંભાર ભગત ઢાંગો, મજેવડીના લુહાર ભગત દેવતણખી અને એમની પુત્રી લીલમબાઈ
                          પણ આવી પહોંચ્યાં.
                          દોહા
                          દેવાયત પંડિત ને, સતી દેવલદે નાર,
                          પાટણ કેરા ભૂપતિ, જેમલજી દરબાર.
                          વંથળીના દેવ દરબારમાંથી દેવાયત પંડિત અને સતી દેવલદે આવ્યાં. પાટણથી નિરલબાઈના પિતા જેમલ રાઠોડ આવ્યા.
                          દોહા
                          મેઘ ધારૂઓ સંતને, રાહોલ માલારાય,
                          આવ્યાં સવારા મંડપે, સતી રૂપાંદે ત્યાંય.
                          મેવાડમાંથી મેવાસા ગામના ઠાકોર રાહોલ માલો, સતી રૂપાંદે અને તેમના
                          ગુરુઓ આવ્યા.
                          દોહા
                          જેસલ તોરલ દીપકીયો, સાંસતિયો ને સધીર,
                          કુંભો નિરલબાઈ ને, ઘેમલ સંત ગંભીર.
                          કચ્છમાં અંજાર શહેરથી, તોરલ, સાંસતિયોજી તથા તેમની વેલ હાંકનાર સેવક દીપકિયો, આબુથી રાણો કુંભો, ચિત્તોડથી કુંભારાણાની પત્ની સતી નિરલબાઈ, જુનાગઢના સંત ઘેમલજી, બિલખાના સગાળશા વંશના ભક્ત સંત ગંભીર શેઠ પણ આવી પહોંચ્યા.
                          દોહા
                          મંડપ મેળામાં મળ્યા, જતિ સતી નરનાર, પધારતા પીર રામદેવ, મંડપની મોજાર.
                        </p>
                        <p className="paragraph-content" >
                          સાયોનને કો
                          બરાબર જમૈયો જામ્યો છે, ભજન ધૂનની રમઝટ બોલે છે.
                          એ
                          શ્રી રામદેવજી મહારાજ ડાલીબાઈની સાથે આવ્યા અને સવરામંડપમાં પ્રવેશ કરે - સહુએ ઊભા થઈ સામૈયું કરી સત્કાર કર્યો અને “પરમપીર રામદેવકી જાય... ધરમવીર નકળંગ કી જય...!' એવી ઘોષણાથી મંડપ અને ચારે દિશાઓ જાગ
                          મૂકી.
                          રાણી પ્રભાવતી પોકાર પાડતી, આંસુ સારતી આવીને ભગવાન રામદ ચરણ પકડી માથું ચરણમાં મૂકી હૈયાફાટ રુદન કરવા લાગી !
                          ‘માતા ! મા ! તને શું થયું છે ? આ સવરામંડપ તો ભજનભાવનો છે, તારા કયા દુઃખને સંભળાવવા આવી છે ? ‘બાપુ ! ધૂન ધણી ! હું દુઃખ સંભળાવવ ત્યાં નહીં પણ રાજાને સાથે લાવી છું. જુઓ ! મારા પતિની સ્થિતિ ! દસ દિવસથી પા તથા અન્નનો ત્યાગ કર્યો છે. તેઓ અંગે અપંગ બન્યા છે. જીવનની ઘડીઓ ગણી રહ્યા છે, ભગવાન ! મારા ભવને ભાંગતો બચાવો !' રાણી રુદન કરતી બોલી ‘દેવી ! મા ! તું સ્વાર્થી છે. તારુ કલ્પાંત તારા પૂરતું જ છે. અત્યારે પાટપૂજાનું કાર્ય ચાલે છે, તે પૂર્ણ થવા દે ! બધા મળ્યા છે, એ કારણ તો તું જાણે છે ને ? જો ! જોઈ લે ! આ સતી ડારલદે’ને ! એના પતિ ખીમડાનો ધજાદંડ સાંજે ભાંગશે, એમની જતિ- સતીની જોડીને તારા પતિએ તોડી નાંખીને ઘોર પાપ કર્યું છે. એ તું કેમ સંભારતી નથી ? તારો પતિ રાજાની ગાડી હાંકનાર રૈવતને તેલમાલિશ કરી રખેવાળું કરનાર હતો ને રાજા બન્યો ! રાજા બનવાથી નીતિ ચૂક્યો અને પાવકની ભઠ્ઠીમાં હાથ નાખ્યો એ તું જાણે છે, માટે શાન્તિ રાખી મૌન બેસ !' રામદેવજીએ ઠપકો આપ્યો અને પાટ-પૂજન વિધિ થવા લાગી.
                          ખીમડે સમાધિ માટે તુરિયાતીત આસનના માપનો ખાડો ખોદીને તૈયાર કર્યો, એટલામાં સાંજ પડવા આવી. સાંજના ચાર વાગતાં પાટની પૂર્ણાહુતિ વખતે ડારલદે’એ આરતી ઉતારી શ્રી રામદેવજીના ચરણે માથું ધર્યું. રામદેવજીએ ખૂબ પ્રસન્નતાથી આશીર્વાદ આપ્યો : ‘ધન્ય છે, શીલવંતી સતી નારી ! નિજારધર્મની અધિકારીણી ! એક પતિવ્રતાધર્મથી નિર્વાણપદ મેળવનારી ભાગ્યશાળી સતી ! તેં ગતગંગાને ઓપ આપ્યો છે. તારી સમાધિ ધૂપ, દિપ અને ધજાથી પૂજાશે.' આમ કહી રામદેવજીએ તેના માથે હાથ મૂક્યો.
                          સતી ડારલદે’એ મંડપમાં બિરાજેલા ધર્મધુરંધરો અને નેજાધરીઓના ચરણનો
                        </p>
                        <p className="paragraph-content" >
                          સતી ડારલદે’એ મંડપમાં બિરાજેલા ધર્મધુરંધરો અને નેજાધરીઓના ચરણનો
                          સતી અરશદે'ની સમાધિ
                          રૂ કરો, માથું નમાવી આશીર્વાદ મેળવ્યા.
                          'કોટવાળ ! આ સમાધિના ખાડા પાસે એક નાનો કુંડી જેટલો ભાગ ખોડો દેવને આજ્ઞા કરી
                          દોહા
                          ખીમડે ખણી વસુંધરા, પ્રગટ્યાં ગંગાનીર,
                          સમાધિને અંજલિ, અલખ રામદેપીર.
                          બીમડે કુંડી જેવો ખાડો ગાળ્યો. ડારલદે' એ સમાધિના ખાડામાં ઊતરતા પહેલાં વિનંતી કરી : 'નાથ ! કોટવાળપદ જીવન પર્યન્ત અડગતાથી પાળજો, હું ચને બંધાઉં છું કે ભવોભવ તમારી પત્ની થઈને સેવા કરીશ. નિર્વાણપદમાં એ સારાગમનના ફેરા મટ્યા હશે તો તમારી સમાધિ પછી તમે નિર્વાણપદના અધિકારી બનશો તો આપણે બંને પતિપત્ની ત્યાં મળીશું.’
                          એટલામાં રામદેવજીએ ખીમડાએ ખોદેલી કુંડીમાં પગ મૂકતાં કુંડીમાંથી ગંગાજી પ્રગટ થયાં અને કુંડી ઊભરાવા લાગી. રામદેવજીએ કુંડીમાંથી અંજલિ ભરી સમાધિને છાંટી, બરાબર એ જ સમયે ડારલદે' જે કૂવામાંથી પાણી ભરતાં હતાં તેમાંથી જમનાજી પ્રગટ થયાં અને કૂવો ઊભરાયો. ખીમડાના ચર્મકુંડમાં ગોમતીજી પ્રગટ થયાં અને તેમાંથી ઝરણું પ્રગટ થયું. આ અલૌકિક ચમત્કાર જોઈ આખું ગામ આશ્ચર્ય પામી ગયું.
                          રામદેવજીએ રાણી પ્રભાવતીને કહ્યું : ‘રાણી ! સતીના ચરણ આ પવિત્ર ત્રિવેણીના જળથી પખાળો અને રણસિંહને લાવીને નમન કરાવી એમને સતીનું ચરણમૃત પાવ !'
                          રાણીએ મરણની ઘડીઓ ગણતા બેભાન બનેલા રણસિંહની લોથને લાવી
                          રાણી પ્રભાવતીએ રણસિંહનો હાથ ઝાલી પતિ-પત્નીએ ડારલદે’ના ચરણ પખાળ્યા રેલદે’ પાસે સુવાડી. ગંગા, જમુના, ગોમતીજીના ત્રિવેણી જળથી પાત્ર ભરીને અને એ ચરણામૃતની અંજલિ ભરી પ્રભાવતીએ રણસિંહના મુખમાં રેડી. ત્યાં તો “જય સતી માતા ! કહીને રાવત રણસિંહ બેઠો થઈ ગયો. તેણે જોયું તો મંડપમાં દેવદરબાર દીઠો. તે સાવ નિરોગી બની ગયો ! રામદેવજી સમાધિની વિધિ કરવા
                          હૈતી ડાલીબાઈ પાસે ગયા.
                          શ્રી રામબ ક
                          ચોપાઈ
                          ક્રમ અર્ચન કીધું કપાળે, સેંથે સિંદુર પૂર્યું રૂપાળું,
                        </p>
                        <p className="paragraph-content" >
                          “જય સતી માતા ! કહીને રાવત રણસિંહ બેઠો થઈ ગયો. તા ૩
                          અને એ ચરણામૃતની અંજલિ ભરી પ્રભા
                          દેવદરબાર દીઠો. તે સાવ નિરોગી બની ગયો ! રામદેવજી સમાધિની વિધિ કરવા ખેતી ડાલીબાઈ પાસે ગયા.
                          શ્રી રામદન ક
                          ચોપાઈ
                          કુંકુમ અર્ચન કીધું કપાળે, સેંથે સિંદુર પૂર્યું રૂપાળે, આપ્યું શ્રીફળ કરની માંહી, વંદન કરતાં ડાલીબાઈ. સતીનું ધર્મચિહ્ન નાગગર્ભ - સિંદુર હોય છે તેથી સતીના સેંથામાં સિંદુર પૂર્ણ સતીના કપાળમાં કંકુની અરચા કરી. અક્ષત (ચોખા) ચોડ્યા. સૌભાગ્યવ હાથમાં મૂકેલા શ્રીફળને વંદન કરતાં સમાધિમાં ઊતરતાં માતાની જેમ ડા બોલ્યાં : પ્રભા ! તારો પતિ રણસિંહ હવે પુનર્જીવન પામ્યો છે. તેના શરીરે કે
                          રોગ નહીં રહે.'
                          ‘મા ! જોગમાયા !’ કહેતો રણસિંહ સમાધિ પાસે ઊભો રહ્યો. ‘રાજા ! હવે . રાજા નથી રહ્યો ! ભગવાન રામદેવજીની કૃપા તારા ઉપર ઊતરી છે, તેથી તને નવ અવતાર મળ્યો છે. તો તું ધર્મધજા ફરકાવજે. સાધુ- સંતોની સેવામાં રહેજે હરિ ૐ... જય અલખ ! ધણી રામદેવજી પરમપીર રામદેવજી મહારાજની જય ! કહી જયનાદ ગજાવતા સતી ડારલદે’ સમાધિમાં ઊતરી ગયાં.
                          ચોપાઈ
                          સાધુ સંત સિદ્ધ ધ્વજધારી, ભક્તો જતિ સતી નરનારી, શ્રીફળ ધૂપ ધજા ફરકાવે, પૂજે સતીની સમાધિ ભાવે. દોહા
                          સતી સમાધિ સિદ્ધની, ગત ગંગા સ્વરૂપ,
                          પરમ ધરમ પરચા થકી, ચડે ધજા ને ધૂપ.
                          રામદેવજીએ રણસિંહને પ્રમોધ્યો અને ખીમડાના સાથીદાર તરીકે એને કોટવાળ પદ આપ્યું. એ વખતે રણસિંહે રામસાગર હાથમાં લઈ ભજનનો લલકાર
                          કર્યો :
                          કર મન ભજનનો વેપાર જી !

                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>{" "}
        </div>
      </div>
      {/* </div>
      </div> */}
      <div>
        <Footer />
        {/* <AudioPlayer state={props.state} onPlay={(isPlay) => this.setState({ isPlay })} /> */}
      </div>
    </>
  );
};

export default BlogDetails9;
